import { Component, Input } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { ISection } from 'interfaces-lib';
import { SectionComponentBase } from '../section-component-base';

@Component({
    selector: 'app-output-file-name-section',
    templateUrl: './output-file-name.component.html',
    styleUrls: ['./output-file-name.component.scss'],
    standalone: false
})
export class OutputFileNameComponent extends SectionComponentBase {
  @Input() formGroup: UntypedFormGroup;

  constructor() {
    super();
  }

  get sourceValue(){
    return this.formGroup.get('sourceValue');
  }

  public static override buildForm(formGroup: UntypedFormGroup, section?: ISection): void {
    formGroup.get('sourceType').setValue('TXT');
    formGroup.get('sourceValue').addValidators([Validators.required, Validators.pattern(/^\S(.*\S)?$/)]);
    formGroup.get('referenceId').setValue(section?.referenceId ?? 'OUTPUT_FILENAME_1');
  }
}
